import api from "@/api/movements";
//  MOVEMENTS ACTION

//  CREATE
const createMovement = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createMovement(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  READ
const readMovementsByBoxId = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readMovementsByBoxId(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const readMovements = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readMovements(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  UPDATE
const updateMovement = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .updateMovement(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  DELETE
const deleteMovement = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteMovement(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export default {
  createMovement,
  readMovements,
  readMovementsByBoxId,
  updateMovement,
  deleteMovement
};
